if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];
/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      //quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        if (value < 1) {
          this.querySelector('.eb-remove-item').click();
        }
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');

              setTimeout(() => {
                document.querySelector('#Product-Drawer-Content').innerHTML = '';
              }, 260);
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
            }
            panel.classList.remove('active');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      let panel = document.querySelector('.side-panel.active');
      if (panel) {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      setTimeout(() => {
        document.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);
    } else {
      document.body.classList.remove('open-cc');
    }
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let button = document.getElementById('cart-drawer-toggle');


    // Add functionality to buttons
    button?.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
      this.container.focus();
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
      });
  }
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });

        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

// Fix images
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    const originalSrc = img.src;
    const pattern = /^https:\/\/www\.edibleblooms\.com\.au\/assets/;
    if (pattern.test(originalSrc)) {
      const newSrc = originalSrc.replace(pattern, 'https://edibleblooms.mymaropost.com/assets');
      img.src = newSrc;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.body.id != 'cart') {
    return;
  }

  fetch(`${theme.routes.cart_url}.js`)
    .then(response => response.json())
    .then(cart => {
      const shoppingCart = new Cart;
      const mainProductIds = new Set(cart.items
        .filter(item => item.properties?._isMainProduct)
        .map(item => item.id)
      );

      cart.items.forEach((item, index) => {
        const parentProductId = Number(item.properties?._parentProductId);
        if (parentProductId && !mainProductIds.has(parentProductId)) {
          shoppingCart.updateQuantity(index + 1, 0);
        }
      });
    });
});

document.addEventListener('DOMContentLoaded', () => {
  const PDPCountdown = document.getElementById('eb-countdown');
  const SiteCountdown = document.getElementById('eb-countdown-bar');
  const getItTodaySelector = '.js-get-it-today';
  const getItTodayDefaultLocation = 'Auckland';
  const getItTodayLocationStorageKey = 'getItTodayLocation';
  const getItTodayLocationCapitalStorageKey = 'getItTodayLocationCapital';

  const visitorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // NZ is a single timezone (Pacific/Auckland) so there's no per-city split like the AU theme had.
  const timezoneToLocationMap = {
    'Pacific/Auckland': 'Auckland'
  };

  const location = timezoneToLocationMap[visitorTimezone] || 'Auckland';

  function parseTime(timeString) {
    const [hour, minute] = timeString.split(':').map(Number);
    return { hour, minute };
  }

  const cutoffTimesWeekday = [
    { city: 'Auckland', ...parseTime(window.cutoffSettings.weekday.auckland) },
    { city: 'Hamilton', ...parseTime(window.cutoffSettings.weekday.hamilton) },
    { city: 'Wellington', ...parseTime(window.cutoffSettings.weekday.wellington) },
    { city: 'Christchurch', ...parseTime(window.cutoffSettings.weekday.christchurch) }
  ];

  const cutoffTimesSaturday = [
    { city: 'Auckland', ...parseTime(window.cutoffSettings.saturday.auckland) },
    { city: 'Hamilton', ...parseTime(window.cutoffSettings.saturday.hamilton) },
    { city: 'Wellington', ...parseTime(window.cutoffSettings.saturday.wellington) },
    { city: 'Christchurch', ...parseTime(window.cutoffSettings.saturday.christchurch) }
  ];

  function getLocationTime() {
    const now = new Date();
    return new Date(now.toLocaleString("en-US", { timeZone: `Pacific/Auckland` }));
  }

  function getCityCapital(cityName) {
    const savedLocation = window.localStorage.getItem(getItTodayLocationStorageKey);
    const savedCapital = window.localStorage.getItem(getItTodayLocationCapitalStorageKey);
    if (savedLocation === cityName && savedCapital) {
      return savedCapital;
    }

    const buttons = document.querySelectorAll('[data-get-it-today-select-location]');
    for (const button of buttons) {
      if (button.dataset.getItTodaySelectLocation === cityName && button.dataset.getItTodayCapital) {
        return button.dataset.getItTodayCapital;
      }
    }
    return cityName;
  }

  function getLocationCountdownState(location, deliveryType = 'same day') {
    const locationTime = getLocationTime();
    const currentDay = locationTime.getDay();
    const currentHour = locationTime.getHours();
    const currentMinute = locationTime.getMinutes();
    const cutoffList = getCutoffForDay(currentDay);
    const capitalCity = getCityCapital(location);
    const cutoff = cutoffList ? cutoffList.find(item => item.city === capitalCity) : null;

    if (isBeforeCutoff(currentHour, currentMinute, cutoff)) {
      const cutoffTime = new Date(locationTime);
      cutoffTime.setHours(cutoff.hour, cutoff.minute, 0, 0);
      const timeRemaining = cutoffTime - locationTime;

      return {
        type: 'countdown',
        hours: Math.floor(timeRemaining / (1000 * 60 * 60)),
        minutes: Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)),
        location,
        deliveryType
      };
    }

    if (deliveryType === 'next day') {
      return {
        type: 'hidden',
        location,
        deliveryType
      };
    }

    return {
      type: 'message',
      message: currentDay >= 1 && currentDay <= 5
        ? `Order now for next day delivery to ${location}.`
        : `Order now for Monday delivery to ${location}.`,
      location,
      deliveryType
    };
  }

  function getSavedGetItTodayLocation() {
    const savedLocation = window.localStorage.getItem(getItTodayLocationStorageKey);
    if (savedLocation) {
      return savedLocation;
    }

    return null;
  }

  function getEffectivePDPCountdownLocation() {
    const savedLocation = getSavedGetItTodayLocation();
    if (savedLocation) {
      return savedLocation;
    }

    return location;
  }

  function getAvailableGetItTodayLocations() {
    const locations = new Set();

    document.querySelectorAll('[data-get-it-today-select-location]').forEach((button) => {
      const location = button.dataset.getItTodaySelectLocation;
      if (location) {
        locations.add(location);
      }
    });

    if (!locations.size) {
      locations.add(getItTodayDefaultLocation);
    }

    return Array.from(locations);
  }

  function getEffectiveGetItTodayLocation(widget) {
    const savedLocation = getSavedGetItTodayLocation();

    if (savedLocation) {
      return savedLocation;
    }

    const availableLocations = getAvailableGetItTodayLocations();
    if (availableLocations.includes(location)) {
      return location;
    }

    return widget.dataset.defaultLocation || getItTodayDefaultLocation;
  }

  function updateGetItTodayLocationButtons(location) {
    document.querySelectorAll('[data-get-it-today-select-location]').forEach((button) => {
      const isActive = button.dataset.getItTodaySelectLocation === location;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function renderGetItTodayCountdown(widget) {
    const message = widget.querySelector('.js-get-it-today-message');
    if (!message) {
      return;
    }

    const location = getEffectiveGetItTodayLocation(widget);
    const deliveryType = widget.dataset.deliveryType || 'same day';
    const state = getLocationCountdownState(location, deliveryType);

    widget.dataset.location = state.location;
    updateGetItTodayLocationButtons(state.location);

    if (state.type === 'countdown') {
      widget.style.removeProperty('display');
      message.innerHTML = `Order within <span class="get-it-today__hours" data-get-it-today-hours>${state.hours} hr</span> <span class="get-it-today__minutes" data-get-it-today-minutes>${state.minutes} min</span> for ${state.deliveryType} delivery to <span class="get-it-today__location-name" data-get-it-today-location>${state.location}</span>.`;
      return;
    }

    if (state.type === 'hidden') {
      widget.style.display = 'none';
      return;
    }

    widget.style.removeProperty('display');
    message.textContent = state.message;
  }

  function updateGetItTodayCountdown() {
    document.querySelectorAll(getItTodaySelector).forEach((widget) => {
      renderGetItTodayCountdown(widget);
    });
  }

  function saveGetItTodayLocation(location) {
    if (!getAvailableGetItTodayLocations().includes(location)) {
      return;
    }

    const capitalCity = getCityCapital(location);
    window.localStorage.setItem(getItTodayLocationStorageKey, location);
    window.localStorage.setItem(getItTodayLocationCapitalStorageKey, capitalCity);
    updateGetItTodayCountdown();
  }

  function handleGetItTodayLocationSelection(target) {
    const locationButton = target.closest('[data-get-it-today-select-location]');

    if (!locationButton) {
      return;
    }

    const location = locationButton.dataset.getItTodaySelectLocation;

    saveGetItTodayLocation(location);

    const modal = locationButton.closest('modal-dialog');
    if (modal && typeof modal.hide === 'function') {
      modal.hide();
    }
  }

  function getCutoffForDay(day) {
    if (day >= 1 && day <= 5) {
      return cutoffTimesWeekday;
    } else if (day === 6) {
      return cutoffTimesSaturday;
    }
    return null;
  }

  function isBeforeCutoff(currentHour, currentMinute, cutoff) {
    if (!cutoff) { return false; }
    return currentHour < cutoff.hour || (currentHour === cutoff.hour && currentMinute < cutoff.minute)
  }

  function updatePDPCountdown() {
    const deliveryType = PDPCountdown.dataset.deliveryType || 'same day';
    const pdpLocation = getEffectivePDPCountdownLocation();
    const state = getLocationCountdownState(pdpLocation, deliveryType);

    if (state.type === 'countdown') {
      PDPCountdown.innerHTML = `Order within <span>${state.hours} hr</span> <span>${state.minutes} min</span> for ${state.deliveryType} delivery to ${state.location}.`;
    } else if (state.type === 'hidden') {
      PDPCountdown.style.display = 'none';
    } else {
      PDPCountdown.innerHTML = state.message;
    }
  }

  function updateSiteCountdown() {
    const locationTime = getLocationTime();
    const currentMonth = locationTime.getMonth();
    const currentDate = locationTime.getDate();
    const currentHour = locationTime.getHours();

    console.log('Location Time:', locationTime);
    console.log('Current Month:', currentMonth);
    console.log('Current Date:', currentDate);
    console.log('Current Hour:', currentHour);

    if (currentMonth !== 11 || (currentMonth === 11 && currentDate <= 22)) {
      const christmasDay = new Date(locationTime.getFullYear(), 11, 22, 0, 0, 0);
      const timeRemaining = christmasDay - locationTime;
      const days = Math.ceil(timeRemaining / (1000 * 60 * 60 * 24));
      SiteCountdown.innerHTML = `Order in the next <span>${days} days</span> for Christmas`;
    } else if (currentMonth === 11 && currentDate === 22 && currentHour < 15) {
      const cutoffTime = new Date(locationTime);
      cutoffTime.setHours(15, 0, 0, 0);
      const timeRemaining = cutoffTime - locationTime;
      const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      SiteCountdown.innerHTML = `Order in the next <span>${hours} hr</span> <span>${minutes} min</span> for Christmas`;
    } else {
      SiteCountdown.closest('.countdown-bar').classList.add('countdown-bar--hidden');
    }
  }

  if (PDPCountdown) {
    updatePDPCountdown();
    setInterval(updatePDPCountdown, 60000);
  }

  const GET_IT_TODAY_ENABLED = false; // Get It Today widget temporarily disabled
  if (GET_IT_TODAY_ENABLED && document.querySelector(getItTodaySelector)) {
    console.log("Initializing Get It Today countdown");
    updateGetItTodayCountdown();
    window.updateGetItTodayCountdown = updateGetItTodayCountdown;
    setInterval(updateGetItTodayCountdown, 60000);
  }

  if (GET_IT_TODAY_ENABLED) {
    document.addEventListener('click', (event) => {
      handleGetItTodayLocationSelection(event.target);
    });
  }

  if (SiteCountdown) {
    updateSiteCountdown();
    setInterval(updateSiteCountdown, 60000);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const el = document.getElementById('kx-content-section');
  if (!el) return;

  const container = el.closest('.shopify-section');
  if (!container) return;

  const wrapper = container.querySelector('.rich-text__inner');
  const description = container.querySelector('.rte');
  if (!wrapper && !description) return;

  const button = `
      <div class="kx-readmore">
          <a href="#">Read More</a>
      </div>
  `;

  wrapper.insertAdjacentHTML('beforeend', button);

  document.querySelector('.kx-readmore a').addEventListener('click', (e) => {
    e.preventDefault();

    if (description.classList.contains('kx-visible')) {
      description.classList.remove('kx-visible');
      document.querySelector('.kx-readmore a').innerHTML = 'Read More';
      wrapper.scrollIntoView();
    } else {
      description.classList.add('kx-visible');
      document.querySelector('.kx-readmore a').innerHTML = 'Read Less';
    }
  });
});

window.addEventListener('load', () => {
  dispatchCustomEvent('cart:refresh');
});

// TODO - Actually move this into the HTML template
function buyBoxRedesign() {
  const container = document.querySelector('.pdp-atc-block');
  const quantity = document.querySelector('.pdp-quantity-block');
  if (!container && !quantity) return;

  const atc = container.querySelector('.product-form');


  const buyBox = document.createElement('div');
  buyBox.classList.add('pdp-atc-container');
  buyBox.appendChild(quantity);
  buyBox.appendChild(atc);
  container.prepend(buyBox);

  // Keep the over-18 age confirmation (alcohol gifts) full width above the quantity/add-to-cart row.
  const ageCheck = container.querySelector(':scope > .kx-age-check');
  if (ageCheck) container.prepend(ageCheck);

  container.classList.add('pdp-atc-block--loaded');
}

window.addEventListener('DOMContentLoaded', function() {
  buyBoxRedesign();
});

// Add event handler for Shopify Form submissions
(function () {
    const orig = window.fetch;
    window.fetch = (...args) => {
        const [res, conf] = args;
        try {
            const url = res.url || res;
            const method = (res.method || conf?.method || 'GET').toUpperCase();
            if (url === 'https://forms.shopifyapps.com/api/v2/form_submission' && method === 'POST') {
                if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
                    Shopify.analytics.publish('shopify_form_submit');
                }
            }
        } catch (e) { }
        return orig.apply(window, args);
    };
})();

document.addEventListener('DOMContentLoaded', () => {
  const BULK_TOGGLE_ENABLED = false; // Bulk order toggle temporarily disabled
  if (!BULK_TOGGLE_ENABLED) return;

  const toggle = document.getElementById('bulk-toggle-input');
  const state = sessionStorage.getItem('bulkOrderMode');

  const breakpoint = window.matchMedia('(max-width: 1219px)');
  if (breakpoint.matches && !document.querySelector('.cart-drawer .bulk-order')) {
    sessionStorage.setItem('bulkOrderMode', 'single');
  }

  if (state === 'multiple') {
    if (toggle) toggle.checked = true;
    document.body.setAttribute('data-bulk-order-mode', 'true');
  }

  if (!toggle) return;
  toggle.addEventListener('change', (e) => {

    if (e.target.checked) {
      document.body.setAttribute('data-bulk-order-mode', 'true');
      sessionStorage.setItem('bulkOrderMode', 'multiple');
      window.pagesense && window.pagesense.push(['trackEvent', 'EBBO: Toggle Bulk Order On']);

    } else  if ( document.querySelector('.cart-drawer .bulk-order') ) {
      // Disallow unchecking if there are bulk orders in the cart
      toggle.checked = true;
      return false;

    } else {
      document.body.removeAttribute('data-bulk-order-mode');
      sessionStorage.setItem('bulkOrderMode', 'single');
      window.pagesense && window.pagesense.push(['trackEvent', 'EBBO: Toggle Bulk Order Off']);

    }
  });

  if (state !== 'multiple') {
    // Check if there are any bulk orders in the cart -- if so, force the state to be multiple

    const cartDrawer = document.getElementById('Cart-Drawer');
    if (!cartDrawer) return;

    cartDrawer.addEventListener('change', () => {
      console.log('cart refreshed event detected');
    });

    const observer = new MutationObserver((mutationsList, observer) => {
      console.log('cart changed');
      console.log('is bulk?', cartDrawer.querySelector('.bulk-order'));

      if (cartDrawer.querySelector('.bulk-order')) {
        document.body.setAttribute('data-bulk-order-mode', 'true');
        sessionStorage.setItem('bulkOrderMode', 'multiple');
        if (toggle) toggle.checked = true;
      }

      observer.disconnect();
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });

  }
});
